import React from 'react';
import { TrainFront } from 'lucide-react';
import { dirMeta } from './RadarPrep';

const fmt = (v) => {
    if (v === null || v === undefined) return '—';
    const n = Number(v);
    return `$${n.toLocaleString('en-US', { maximumFractionDigits: n >= 1000 ? 2 : n >= 1 ? 4 : 8 })}`;
};

/** "TREN KAÇTI": the move already happened — no HAZIRLAN, only a pullback plan. */
export default function RadarLateCard({ row, onSelect }) {
    const rd = row.radar;
    const ext = rd.extension || {};
    const m = dirMeta(rd.direction);
    const p = rd.order_plan;
    return (
        <button
            type="button"
            onClick={() => onSelect?.(row.symbol)}
            data-testid={`radar-late-card-${row.symbol}`}
            className="text-left w-full rounded-lg border border-amber-500/40 bg-amber-950/20 hover:border-amber-400/70 transition-colors p-2.5 space-y-1.5"
        >
            <div className="flex items-center gap-1.5">
                <TrainFront className="h-3.5 w-3.5 text-amber-300 shrink-0" />
                <span className="font-mono font-bold text-sm text-slate-50">{row.symbol.replace('USDT', '')}</span>
                {m && <span className={`text-[10px] font-semibold ${m.cls}`}>{m.arrow} {rd.direction.toUpperCase()}</span>}
                <span className="ml-auto font-mono text-[11px] text-amber-200" data-testid={`radar-late-change-${row.symbol}`}>
                    {Number(ext.change_pct_24h ?? row.change_pct_24h ?? 0) >= 0 ? '+' : ''}{Number(ext.change_pct_24h ?? row.change_pct_24h ?? 0).toFixed(1)}% 24s
                </span>
            </div>
            <div className="text-[10px] font-bold uppercase tracking-wider text-amber-200">Tren kaçtı — kovalama yapma</div>
            <div className="text-[10px] text-slate-300 leading-snug" data-testid={`radar-late-reasons-${row.symbol}`}>
                {(ext.reasons_tr || []).join(' · ')} · {rd.passed_count}/7 teyit var ama HAZIRLAN sayılmaz
            </div>
            {p && (
                <div data-testid={`radar-late-plan-${row.symbol}`} className="rounded-md border border-slate-600/70 bg-slate-950/60 px-2 py-1.5 text-[10px] font-mono text-slate-200 space-y-0.5">
                    <div className="text-slate-400 font-sans text-[9px] uppercase tracking-wider">Geri çekilme planı · 1x</div>
                    <div>Limit {p.side === 'LONG' ? 'alış' : 'satış'} geri testte: {fmt(p.entry_low)} – {fmt(p.entry_high)}</div>
                    <div>Stop {fmt(p.stop)} ({p.stop_pct}%) · TP1 {fmt(p.tp1)} ({p.tp1_pct > 0 ? '+' : ''}{p.tp1_pct}%) · R/R {p.rr}</div>
                    <div className="text-slate-400 font-sans">Fiyat oraya sakin gelmezse işlem yok.</div>
                </div>
            )}
        </button>
    );
}
